import { useTranslation } from 'react-i18next';
import usePageMeta from '@/hooks/usePageMeta';
import PageHero from '@/components/feature/PageHero';
import ContactInfoSection from '@/pages/contact/components/ContactInfoSection';
import ContactForm from '@/pages/contact/components/ContactForm';

export default function Contact() {
  const { t } = useTranslation();

  usePageMeta({
    title: 'Kontakt | S+N Blech- und Metallverarbeitung',
    description:
      'Nehmen Sie Kontakt mit der S+N Blech- und Metallverarbeitungs GmbH auf: Beierfelder Str. 22, 08315 Lauter-Bernsbach, Telefon 03774 - 662149, info@sn-metall.de.',
    keywords: 'Kontakt Blechbearbeitung, Anfrage Metallverarbeitung, Lauter-Bernsbach',
  });

  return (
    <>
      <PageHero
        eyebrow={t('contact.hero.eyebrow')}
        title={t('contact.hero.title')}
        subtitle={t('contact.hero.subtitle')}
      />
      <ContactInfoSection />
      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto w-full max-w-content px-4 md:px-6">
          <div className="mx-auto max-w-3xl">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}